import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Catalogue = () => {
  const [catalogueData, setCatalogueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const getCatalogue = () => {
    axios.post(API_URL.CATALOGUE_LIST, { is_seller: [0, 1] }).then(
      (res) => {
        if (res.data.status === 1) {
          setCatalogueData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteCatalogue = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Catalogue ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CATALOGUE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = catalogueData.filter((r) => r.id != row.id);
              setCatalogueData(newData);
              toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            } else {
              toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getCatalogue();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Catalogue
            <small className="me-2">({catalogueData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/settings/catalogue/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              Catalogue
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Size</th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {catalogueData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{ width: "10px" }}>{key + 1}</td>
                            <td>
                              {row.name}
                            </td>
                            <td>
                              {row.size_name}
                            </td>

                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/settings/catalogue/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteCatalogue(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Catalogue;
